module.exports = __webpack_public_path__ + "img/5.bc2b6921.svg";